import { ref } from "vue";

const CURRENCY_SYMBOLS = { USD: "$", EUR: "€", GBP: "£", TZS: "TSh ", KES: "KSh ", INR: "₹" };

export const appCurrency = ref("USD");

export function setAppCurrency(code) {
	if (code) appCurrency.value = code;
}

export function money(value, currency, { decimals = 2 } = {}) {
	const code = currency || appCurrency.value;
	const amount = Number(value || 0);
	const symbol = CURRENCY_SYMBOLS[code] || `${code} `;

	return `${symbol}${amount.toLocaleString("en-US", {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	})}`;
}

export function compactMoney(value) {
	const amount = Number(value || 0);
	if (Math.abs(amount) >= 1000) return `${Math.round(amount / 1000)}K`;
	return String(Math.round(amount));
}

export function number(value, decimals = 0) {
	return Number(value || 0).toLocaleString("en-US", {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});
}

export function percent(value, decimals = 2) {
	return `${Number(value || 0).toFixed(decimals)}%`;
}

export function shortDate(value) {
	if (!value) return "";
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return String(value);

	return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function dayMonth(value) {
	if (!value) return "";
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return String(value);

	return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
}

export function longDate(value) {
	if (!value) return "";
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return String(value);

	return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function weekday(value) {
	if (!value) return "";
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return "";

	return date.toLocaleDateString("en-GB", { weekday: "long" });
}

export function relativeTime(value) {
	if (!value) return "";
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return String(value);

	const diffMinutes = Math.round((Date.now() - date.getTime()) / 60000);
	if (diffMinutes < 1) return "just now";
	if (diffMinutes < 60) return `${diffMinutes} minutes ago`;

	const diffHours = Math.round(diffMinutes / 60);
	if (diffHours < 24) return `${diffHours} hours ago`;

	const diffDays = Math.round(diffHours / 24);
	if (diffDays < 30) return `${diffDays} days ago`;

	return shortDate(value);
}

export function lines(value) {
	return String(value || "")
		.split("\n")
		.map((line) => line.trim())
		.filter(Boolean);
}

export const SERVICE_STATUS_LABELS = {
	QT: "Quote Only",
	RQ: "Requested",
	OK: "Confirmed",
	XX: "Cancelled",
};
